import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					padding: "0",
					backgroundImage: `url(${banner5})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				
				<div className="container">
					<div className="row" >

						<div 
							className="col-md-6"
							style={{
								height: "300px"
							}}
						>
							
						</div>

						<div className="col-md-6">
							
							<div
								style={{
									padding: "20px",
									marginTop: "30px",
									marginBottom: "30px",
									background: "rgba(255, 255, 255, 0.7)",
								}}

								className=""
							>
								<h6
									className="main-section-title"
								>
									Our Story
									<span
										style={{
											display: "block",
											borderBottom: "3px solid var(--secondaryColor)",
											width: "50px",
											marginTop: "10px"
										}}
									>

									</span>
								</h6>

								<p
									style={{
										fontSize: "18px"
									}}
								>
									Caremed Gas Ltd is a reputable and highly experienced company specializing in the supply of medical gases and industrial gases. We have proudly served numerous healthcare institutions—both public and private—across the country and beyond, providing reliable and modern Medical Gas Pipeline Systems (MGPS).
									<br/><br/>
									Our team is composed of skilled, professional, and highly trained experts dedicated to the design, installation, commissioning, and maintenance of medical gas systems. We operate strictly under international safety and quality standards, ensuring that every project is executed with precision and excellence.
									<br/><br/>
									At Caremed Gas Ltd, quality, reliability, and customer trust form the foundation of our work. We ensure that every project is delivered with outstanding workmanship, long-lasting performance, and full compliance with healthcare engineering requirements.
								</p>

								<div className="text-end mt-5">
									<button
										className="btn btn-padded btn-rounded btn-primary"
										style={{
											margin: "10px",

										}}
										onClick={() => {
											appContext.navTo({
												item: 'about_us'
											})
										}}
									>
										Learn More...
									</button>
								</div>
							</div>

						</div>

						
					</div>

				
				</div>
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
